export const ADD_ROLE_MODULE_PERMISSIONS = 'ADD_ROLE_MODULE_PERMISSIONS'
export const GET_ROLE_MODULE_PERMISSIONS_BY_LEVEL = 'GET_ROLE_MODULE_PERMISSIONS_BY_LEVEL'
export const DELETE_ROLE_MODULE_PERMISSIONS_BY_LEVEL = 'DELETE_ROLE_MODULE_PERMISSIONS_BY_LEVEL'
